export const formatResistorString = (value: number): string => {
    if (value < 1) {
        const milli = value * 1000;
        return `${parseFloat(milli.toFixed(4))} mΩ`;
    } else if (value >= 1000) {
        const kilo = value / 1000;
        return `${parseFloat(kilo.toFixed(4))} kΩ`;
    } else {
        return `${parseFloat(value.toFixed(4))} Ω`;
    }
};